module.exports = __webpack_public_path__ + "media/images/mypage/icon/black/ico_calendar-9eda43f52e670c6da29fe6d61aef6658.svg";